import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import {
  useAPIGetPelaksanaanPengembanganKompetensi,
  useAPISubmitPelaksanaanPengembanganKompetensi,
} from 'api/kinerja/penilik-pegawai/pelaksanaan'
import { usePenilikStatus } from './useSummary'

export const usePelaksanaanPengembanganKompetensi = () => {
  const { isHavePeriod } = usePeriodContext()
  const { summary: penilikSummary } = usePenilikStatus({
    disabled: !isHavePeriod,
  })
  const { data: pelaksanaan, status: apiStatus } =
    useAPIGetPelaksanaanPengembanganKompetensi({
      skpId: penilikSummary?.skpId,
      enabled: !!penilikSummary?.skpId && isHavePeriod,
    })
  const { mutateAsync: submitPelaksanaan, status: apiStatusSubmit } =
    useAPISubmitPelaksanaanPengembanganKompetensi({
      skpId: penilikSummary?.skpId,
    })

  return {
    pelaksanaan,
    submitPelaksanaan,
    apiStatus,
    apiStatusSubmit,
  }
}
